import { Helmet } from 'react-helmet-async';

const serverStatus = [
  { name: 'Servidor Chile 1', status: 'operational', uptime: '99.98%' },
  { name: 'Servidor Chile 2', status: 'operational', uptime: '99.99%' },
  { name: 'Servidor USA', status: 'operational', uptime: '99.97%' },
  { name: 'Servidor Europa', status: 'operational', uptime: '99.95%' },
];

export default function EstadoServidoresPage() {
  return (
    <>
      <Helmet>
        <title>Estado de Servidores en Tiempo Real | Monitoreo 24/7 de Infraestructura en Chile</title>
        <meta name="description" content="Monitoreo en tiempo real del estado de nuestros servidores en Chile, EEUU y Europa. Uptime, disponibilidad y rendimiento de infraestructura de hosting y VPS actualizado cada minuto." />
        <meta name="keywords" content="estado servidores chile, uptime hosting chile, monitoreo servidores tiempo real, disponibilidad hosting santiago, status servidores" />
        <link rel="canonical" href="https://www.ehostingchile.cl/soporte/estado-servidores" />
        <meta property="og:title" content="Estado de Servidores en Tiempo Real | Monitoreo 24/7 de Infraestructura en Chile" />
        <meta property="og:description" content="Monitoreo en tiempo real del estado de nuestros servidores en Chile, EEUU y Europa." />
        <meta property="og:url" content="https://www.ehostingchile.cl/soporte/estado-servidores" />
      </Helmet>

      <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-cyan-50">
        {/* Hero Section */}
        <section className="relative pt-32 pb-8 overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-br from-blue-600/5 via-cyan-500/5 to-teal-500/5"></div>
          <div className="container mx-auto px-4 relative z-10">
            <div className="max-w-4xl mx-auto text-center">
              <div className="inline-flex items-center justify-center w-20 h-20 rounded-2xl bg-gradient-to-br from-emerald-500 to-teal-500 text-white mb-6 shadow-lg shadow-emerald-500/30">
                <i className="ri-server-line text-4xl"></i>
              </div>
              <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-4">
                Estado de Servidores
              </h1>
              <p className="text-lg text-gray-600 mb-6">
                Monitoreo en tiempo real de nuestra infraestructura · Actualizado cada minuto
              </p>
              <div className="flex flex-wrap justify-center gap-4 text-sm">
                <div className="flex items-center gap-2 px-4 py-2 bg-white rounded-lg shadow-md">
                  <div className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse"></div>
                  <span className="text-gray-700 font-semibold">Monitoreo 24/7</span>
                </div>
                <div className="flex items-center gap-2 px-4 py-2 bg-white rounded-lg shadow-md">
                  <i className="ri-time-line text-teal-600"></i>
                  <span className="text-gray-700 font-semibold">Actualización automática</span>
                </div>
                <div className="flex items-center gap-2 px-4 py-2 bg-white rounded-lg shadow-md">
                  <i className="ri-history-line text-emerald-600"></i>
                  <span className="text-gray-700 font-semibold">Historial completo</span>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Server Status Cards */}
        <section className="py-10">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto space-y-4">
              {serverStatus.map((server, index) => (
                <div
                  key={index}
                  className="bg-white rounded-xl p-6 shadow-lg border border-gray-100"
                >
                  <div className="flex items-center justify-between flex-wrap gap-4">
                    <div className="flex items-center gap-4">
                      <div className="w-3 h-3 rounded-full bg-emerald-500 animate-pulse"></div>
                      <h3 className="text-lg font-bold text-gray-900">
                        {server.name}
                      </h3>
                    </div>
                    <div className="flex items-center gap-6">
                      <div className="text-right">
                        <div className="text-sm text-gray-500 mb-1">Uptime</div>
                        <div className="text-lg font-bold text-emerald-600">
                          {server.uptime}
                        </div>
                      </div>
                      <div className="px-4 py-2 rounded-lg font-semibold bg-emerald-50 text-emerald-700">
                        Operacional
                      </div>
                    </div>
                  </div>
                </div>
              ))}
              <p className="text-sm text-gray-400 text-right pt-1">
                Última actualización: hace 2 minutos
              </p>
            </div>
          </div>
        </section>

        {/* Iframe Section */}
        <section className="pb-16">
          <div className="container mx-auto px-4">
            <div className="max-w-7xl mx-auto">
              <div className="bg-white rounded-2xl shadow-2xl border border-gray-100 overflow-hidden">
                <div className="bg-gradient-to-r from-gray-900 to-gray-800 px-6 py-4">
                  <div className="flex items-center justify-between flex-wrap gap-3">
                    <div className="flex items-center gap-3">
                      <div className="w-3 h-3 rounded-full bg-emerald-500 animate-pulse"></div>
                      <h2 className="text-white font-bold text-lg">
                        Monitoreo en Vivo
                      </h2>
                    </div>
                    <a
                      href="https://stats.uptimerobot.com/oG5NUHEaZT"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center gap-2 px-4 py-2 bg-white/10 hover:bg-white/20 text-white rounded-lg transition-all text-sm font-semibold whitespace-nowrap"
                    >
                      <i className="ri-external-link-line"></i>
                      Abrir en nueva ventana
                    </a>
                  </div>
                </div>

                <div className="relative w-full" style={{ minHeight: '800px' }}>
                  <iframe
                    src="https://stats.uptimerobot.com/oG5NUHEaZT"
                    title="Estado de Servidores - UptimeRobot"
                    className="w-full border-0"
                    style={{ height: '800px', minHeight: '600px' }}
                    loading="lazy"
                  />
                </div>
              </div>

              {/* Info Cards */}
              <div className="grid md:grid-cols-3 gap-6 mt-8">
                <div className="bg-white rounded-xl p-6 shadow-lg border border-gray-100">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-emerald-50 text-emerald-600">
                      <i className="ri-shield-check-line text-2xl"></i>
                    </div>
                    <h3 className="font-bold text-gray-900">Uptime Garantizado</h3>
                  </div>
                  <p className="text-gray-600 text-sm">
                    Garantizamos 99.9% de disponibilidad en todos nuestros servidores con SLA respaldado.
                  </p>
                </div>

                <div className="bg-white rounded-xl p-6 shadow-lg border border-gray-100">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-teal-50 text-teal-600">
                      <i className="ri-refresh-line text-2xl"></i>
                    </div>
                    <h3 className="font-bold text-gray-900">Actualización Continua</h3>
                  </div>
                  <p className="text-gray-600 text-sm">
                    El estado se actualiza automáticamente cada 60 segundos para información precisa.
                  </p>
                </div>

                <div className="bg-white rounded-xl p-6 shadow-lg border border-gray-100">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-emerald-50 text-emerald-600">
                      <i className="ri-notification-line text-2xl"></i>
                    </div>
                    <h3 className="font-bold text-gray-900">Alertas Proactivas</h3>
                  </div>
                  <p className="text-gray-600 text-sm">
                    Nuestro equipo es notificado instantáneamente ante cualquier incidencia.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
